import { render, staticRenderFns } from "./RefProductsListFilters.vue?vue&type=template&id=0e35fd79"
import script from "./RefProductsListFilters.vue?vue&type=script&lang=js"
export * from "./RefProductsListFilters.vue?vue&type=script&lang=js"
import style0 from "./RefProductsListFilters.vue?vue&type=style&index=0&id=0e35fd79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports